export default __webpack_public_path__ + "static/0100-ec757bbdcf5f9190e3ea855b5190119d.png";